import { z } from 'zod';
import { IsoDateTimeSchema, ModuleCodeSchema, UuidSchema } from './common.js';
export const AuditActionSchema = z.enum([
    'auth.login',
    'auth.login_failed',
    'auth.refresh',
    'auth.refresh_reuse_detected',
    'auth.logout',
    'auth.password_reset_requested',
    'auth.password_set',
    'user.create',
    'user.update',
    'user.delete',
    'user.disable',
    'module.assign',
    'module.revoke',
    'sucursal.create',
    'sucursal.update',
    'sucursal.delete',
    'cliente.create',
    'cliente.update',
    'cliente.delete',
    'cliente.avatar.update',
    'guardia.create',
    'guardia.update',
    'guardia.delete',
    'guardia.avatar.update',
    'horas.create',
    'horas.update',
    'horas.delete',
    'personal_document.create',
    'personal_document.delete',
    'cliente_contrato.create',
    'cliente_contrato.delete',
    'caja.create',
    'caja.update',
    'caja.delete',
    'caja.open',
    'caja.close',
    'cierre.create',
    'transaccion.create',
    'transaccion.update',
    'transaccion.delete',
    'categoria.create',
    'categoria.update',
    'categoria.delete',
    'presupuesto.create',
    'presupuesto.update_estado',
    'contacto.create',
    'pre_reserva.create',
    'recaudacion.create',
    'recaudacion.update',
    'recaudacion.delete',
    'banco.movimiento.create',
    'banco.movimiento.update',
    'banco.movimiento.delete',
    'efectivo.movimiento.create',
    'efectivo.movimiento.update',
    'efectivo.movimiento.delete',
    'efectivo.transferencia.create',
    'pago.create',
    'pago.update',
    'pago.delete',
    'adelanto.create',
    'adelanto.update',
    'adelanto.delete',
    'vehiculo.create',
    'vehiculo.update',
    'vehiculo.delete',
    'vehiculo.foto.update',
    'combustible.create',
    'combustible.update',
    'combustible.delete',
    'inventario.create',
    'inventario.update',
    'inventario.delete',
    'inventario_asignacion.create',
    'inventario_asignacion.delete',
    'inventario_asignacion.devolver',
    'licencia.create',
    'licencia.update',
    'licencia.delete',
    'licencia.documento.update',
    'empresa.create',
    'empresa.update',
    'empresa.delete',
    'empresa_visep.create',
    'empresa_visep.delete',
    'suscripcion.create',
    'suscripcion.update',
    'suscripcion.delete',
    'suscripcion_pago.create',
    'suscripcion_pago.update',
    'suscripcion_pago.delete',
    'suscripcion_cronograma.create',
    'suscripcion_cronograma.generar',
    'suscripcion_plan.generar',
    'suscripcion_cronograma.delete',
    'suscripcion_cuota.cobrar',
    'recibo.create',
    'recibo.update',
    'recibo.delete',
    'factura.create',
    'factura.emitir',
    'factura.emitir_error',
    'factura.consultar_estado',
    'factura.email',
    'finanzas.reset',
    'caja_usuario.assign',
    'caja_usuario.unassign',
    'sucursal_usuario.assign',
    'sucursal_usuario.unassign',
    'multa.create',
    'multa.delete',
    'descuento_parcelado.create',
    'descuento_parcelado.delete',
    'descuento_cuota.reprogramar',
    'planilla.cierre',
]);
export const AuditLogEntrySchema = z.object({
    id: UuidSchema,
    userId: UuidSchema.nullable(),
    module: ModuleCodeSchema.nullable(),
    action: AuditActionSchema.nullable(),
    details: z.record(z.string(), z.unknown()).nullable(),
    ipAddress: z.string().nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
    // A-8: nome do usuário resolvido pela trilha (widget mostrava o userId truncado).
    user: z.object({ nombreCompleto: z.string().nullable() }).nullable().optional(),
});
//# sourceMappingURL=audit.js.map